import { getInvoiceListingColumns, getInvoiceListingRows } from "./invoice-listing-statement";
import { getInvoiceListing } from "@/api/finance/reportApi";
import {
  DynamicReport
} from "@/components/dynamic";

const invoiceListingFilters = {
  InvoiceNumber: "*",
  InvoiceType: "*",
  TenantNumber: "*",
  ContractNumber: "*",
};

const invoiceListingFilterOptions = [
  { key: "invoiceNumber", apiKey: "InvoiceNumber" },
  { key: "invoiceType", apiKey: "InvoiceType" },
  { key: "tenantNumber", apiKey: "TenantNumber" },
  { key: "contractNumber", apiKey: "ContractNumber" },
];

export default function RentRollReport({ activeCompany }) {
  return (
    <DynamicReport
      reportName="invoice-listing"
      activeCompany={activeCompany}
      columnsDataProvider={getInvoiceListingColumns}
      rowsDataProvider={getInvoiceListingRows}
      fetchData={(data) => getInvoiceListing(data)}
      exportUrl="reports/export-query-report/invoice-listing"
      filtersInitialState={invoiceListingFilters}
      filterOptions={invoiceListingFilterOptions}
      orderBy="InvoiceNumber"
    />
  );
}
